import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // ✅ Tailwind
import App from "./App";
import Login from "./components/Login";


import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import SetPassword from "./components/SetPassword";
import EmailPasswordLogin from "./components/EmailPasswordLogin";
import Unsubscribe from "./components/email-preferences";
import Profile from "./components/Profile";
import PublicProfile from "./components/PublicProfile";
import { supabase } from "./supabaseClient"; // ⬅ same client used elsewhere

// import ContestPage from "./ContestPage";

// Small wrapper that handles session + route protection
const AppRouter = () => {
  const location = useLocation();
  const [session, setSession] = useState(null);
  const [sessionChecked, setSessionChecked] = useState(false);

  // Public routes that do NOT require auth
  const publicPaths = ["/", "/login", "/email-login", "/set-password","/email-preferences" ];

  useEffect(() => {
    const getSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setSession(session);
      setSessionChecked(true);
    };

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    getSession();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  // While we don't yet know if a session exists, show a minimal loader
  if (!sessionChecked) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-200">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-600 border-t-indigo-400" />
          <p className="text-xs text-slate-400">
            Loading your Dreamframe experience…
          </p>
        </div>
      </div>
    );
  }

  // ✅ If already logged in and we're on landing or login, push to dashboard
  if (session && (location.pathname === "/" || location.pathname === "/login")) {
    return <Navigate to="/dashboard" replace />;
  }

  // 🔒 Redirect unauthenticated users away from protected routes
  if (!session && !publicPaths.includes(location.pathname)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      {/* Public landing page */}
      <Route path="/" element={<App />} />

      {/* Auth / public auth-related routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/email-login" element={<EmailPasswordLogin />} />
      <Route path="/email-preferences" element={<Unsubscribe />} />

      {/* Auth-required routes (session must exist) */}
      <Route path="/profile" element={<Profile />} />
      <Route path="/profile/edit" element={<Profile />} />
      <Route path="/profile/:user_id" element={<PublicProfile />} />
      <Route path="/dashboard/*" element={<Dashboard />} />
      {/* <Route path="/contest" element={<ContestPage />} /> */}

      {/* Fallback: unknown routes → landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
